// src/data/templates.js
export const templatesData = [
    {
      id: 1,
      name: "Murat Sisli",
      case: "Insurance Case 11-2024",
      
      date: "Apr 23",
      subscriber:234
    },
    {
      id: 2,
      name: "Ahmet Usta",
      case: "Car Accident Case 10-2024",
      date: "Apr 23",
      subscriber:234
    },
    {
      id: 3,
      name: "Enver Hoca",
      case: "Divorce Case 11-2024",
      date: "Apr 23",
      subscriber:234
   
    },
    {
      id: 4,
      name: "Mega Tech IT",
      case: "Open Payments Case 09-2024",
      date: "Apr 23",
      subscriber:234
  
    },
  ];
  